// import packages
import gql from "graphql-tag"

// export gqls
export const GET_PRICEBOOKS = gql`
  query priceBooks($take: Int, $skip: Int, $input: PriceBookFilterInput) {
    priceBooks(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        price
        company {
          id
          name
        }
        product {
          id
          name
        }
      }
    }
  }
`
export const SUM_PRICEBOOKS = gql`
  query priceBooks($take: Int, $skip: Int) {
    priceBooks(take: $take, skip: $skip) {
      total
    }
  }
`

export const GET_PRICEBOOK = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      price
      company {
        id
        name
      }
      product {
        id
        name
      }
    }
  }
`


export const UPDATE_PRICEBOOK = gql`
  mutation updatePriceBook($id: ID!, $input: updatePriceBook!) {
    updatePriceBook(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_PRICEBOOK = gql`
  mutation createPriceBook($input: PriceBookCreateInput!) {
    createCompany(input: $input) {
      id
    }
  }
`

export const DELETE_PRICEBOOK = gql`
  mutation deletePriceBook($id: ID!) {
    deletePriceBook(id: $id)
  }
`

export const GET_COMPANIES = gql`
  query Companies($take: Int) {
    companies(take: $take) {
      data {
        id
        name
        companyNumber
      }
    }
  }
`

export const GET_PRODUCTS = gql`
  query products($take: Int, $skip: Int, $input: ProductQueryInput) {
    products(take: $take, skip: $skip, input: $input) {
      data {
        id
        name
      }
    }
  }
`
